var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"icons-row",class:_vm.ifMenuVariant},[_c('div',{staticClass:"version"},[_c('version-display')],1),_vm._v(" "),_c('div',{staticClass:"theme"},[_c('theme-changer')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }